import React from 'react';
import Button from '@nubank/nuds-web/components/Button/Button';

import { StyledHeader } from '../../../../styles/Header';
import { useSiteContext } from '../../../../../../../../components/SiteContext/SiteContext';

const CloseBtn = () => {
  const { closeRegistrationForm } = useSiteContext();
  return (
    <StyledHeader>
      <Button
        variant="basic"
        onClick={() => closeRegistrationForm(true)}
        iconProps={{
          name: 'x', title: 'Cerrar',
        }}
      />
    </StyledHeader>
  );
};

export default CloseBtn;
